module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-9.0539a295.jpg";